export class ApiService {
    constructor(serviceUrl, sessionService) {
        this.serviceUrl = serviceUrl;
        this.sessionService = sessionService;
    }
    get(path) {
        const headers = {};
        if (this.sessionService.isLoggedIn) {
            headers['X-Access-Token'] = this.sessionService.accessToken;
        }
        return fetch(`${this.serviceUrl}/${path}`, {
            headers
        });
    }
    post(path, body) {
        const headers = {};
        if (!(body instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(body);
        }
        if (this.sessionService.isLoggedIn) {
            headers['X-Access-Token'] = this.sessionService.accessToken;
        }
        return fetch(`${this.serviceUrl}/${path}`, {
            method: 'POST',
            headers,
            body,
        });
    }
    put(path, body) {
        const headers = {};
        if (!(body instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(body);
        }
        if (this.sessionService.isLoggedIn) {
            headers['X-Access-Token'] = this.sessionService.accessToken;
        }
        return fetch(`${this.serviceUrl}/${path}`, {
            method: 'PUT',
            headers,
            body,
        });
    }
    delete(path) {
        const headers = {};
        if (this.sessionService.isLoggedIn) {
            headers['X-Access-Token'] = this.sessionService.accessToken;
        }
        return fetch(`${this.serviceUrl}/${path}`, {
            method: 'DELETE',
            headers,
        });
    }
}
